<template>
  <main class="native-required">
    <div class="container native-required__container">
      <section class="card native-required__card text-center">
        <div class="native-required__icon" aria-hidden="true">
          <i class="fa-brands fa-google-play"></i>
        </div>

        <h1 class="native-required__title">Baixe o aplicativo para continuar</h1>
        <p class="native-required__text">
          O LeCard Entregador está disponível exclusivamente pelo aplicativo.
        </p>

        <a
          v-if="playStoreUrl"
          :href="playStoreUrl"
          class="btn btn-primary"
        >
          <i class="fa-brands fa-google-play"></i>
          Baixar na Play Store
        </a>

        <p v-else class="alert alert-warning mb-0">
          O link para download ainda não está disponível.
        </p>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'NativeAndroidRequired',

  computed: {
    playStoreUrl() {
      return (process.env.VUE_APP_PLAY_STORE_URL || '').trim();
    }
  }
};
</script>

<style scoped>
.native-required {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  padding: calc(32px + var(--safe-area-inset-top, env(safe-area-inset-top, 0px))) 0 calc(32px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)));
}

.native-required__container {
  width: 100%;
}

.native-required__card {
  max-width: 430px;
  margin: 0 auto;
  padding: 36px 24px 28px;
}

.native-required__icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  background-color: rgba(199, 244, 123, 0.22);
  border: 1px solid rgba(199, 244, 123, 0.36);
  color: #a3c613;
  font-size: 2rem;
}

.native-required__title {
  margin-bottom: 12px;
  font-size: 1.45rem;
  line-height: 1.25;
  font-weight: 700;
}

.native-required__text {
  margin-bottom: 28px;
  color: var(--text-muted);
}

.dark-mode .native-required__icon {
  background-color: rgba(199, 244, 123, 0.14);
  border-color: rgba(199, 244, 123, 0.2);
  color: var(--primary);
}
</style>
